import { Column } from "react-table";
import { formatDate } from "../../api/DateUtils";
import {
  GetIncidentCorrectiveAndPreventativeActionsFetchUrl,
  IIncidentCorrectiveAndPreventativeAction,
} from "../../api/Incident/IIncidentCorrectiveAndPreventativeAction";
import { Grid } from "../Grid";
import { IncidentCorrectiveAndPreventativeActionsGridProps } from "./IncidentCorrectiveAndPreventativeActionsGridProps";

const IncidentCorrectiveAndPreventativeActions = ({
  incidentId,
  licenceProfile,
}: IncidentCorrectiveAndPreventativeActionsGridProps) => {
  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetIncidentCorrectiveAndPreventativeActionsFetchUrl(
        relatedId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(incidentId);

  const tableColumnsBig: Column<
    Record<string, IIncidentCorrectiveAndPreventativeAction>
  >[] = [
    {
      Header: "Action Date",
      accessor: "actiondate",
      Filter: false,
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Action Type",
      accessor: "actiontype",
      Filter: false,
    },
    {
      Header: "Action",
      accessor: "action",
      Filter: false,
    },
  ];

  const tableColumnsSmall: Column<
    Record<string, IIncidentCorrectiveAndPreventativeAction>
  >[] = [
    {
      Header: "Action Date",
      accessor: "actiondate",
      Filter: false,
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Action Type",
      accessor: "actiontype",
      Filter: false,
    },
    {
      Header: "Action",
      accessor: "action",
      Filter: false,
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { IncidentCorrectiveAndPreventativeActions };
